var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"component",staticClass:"ui-hover-group",class:{ 'is-active': _vm.active },on:{"dragstart":function($event){$event.preventDefault();}}},'component',_vm.componentAttributes,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }